import React, { useState } from 'react';
import { ReleaseBrowseCommon } from './../browse/ReleaseBrowseCommon';
import { Header, Divider, Icon } from 'semantic-ui-react'

export function OrganisationReleases(props) {
	const [childRendering, setChildRendering] = useState(true);
	return (
		<>
			{childRendering &&
				<>
					<Divider horizontal inverted>
						<Header as='h4' inverted>
							<Icon name='disc' />
							Releases
						</Header>
					</Divider>
					<ReleaseBrowseCommon slim={true} label={props.organisation}
						urlParams={false} relatedRendered={(val) => setChildRendering(val)}/>
				</>
			}
		</>
	);
}